// extracted by mini-css-extract-plugin
export default {"Main":"GetAquote_Main__lnqnV","Sub":"GetAquote_Sub__OL5uk","Call":"GetAquote_Call__cJcaA","Num":"GetAquote_Num__8AXEy"};